<template>
	<el-dialog :visible.sync="visible" class="add-wrap" :show-close="false" :title="title" center>
		<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
		  <el-form-item label="通知标题" width="100">
		    <el-input v-model="formLabelAlign.name" placeholder="请输入通知标题"></el-input>
		  </el-form-item>
		  <el-form-item label="通知人员">
		    <el-input v-model="formLabelAlign.region" placeholder="请选择要通知的人员"></el-input>
		  </el-form-item>
		  <el-form-item label="通知内容">
		    <el-input v-model="formLabelAlign.type"  type="textarea" placeholder="请输入通知内容（建议150字以内）"></el-input>
		 </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="_cancel">取&nbsp;消</el-button>
			<el-button type="primary" @click="_sure">保&nbsp;存</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
  name: "addInform",
  props: {
    visible: {
      type: Boolean,
      default: false
		},
		title: {
			type: String,
			default: '编辑通知'
		}
  },
  data() {
    return {
      labelPosition: "left",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      }
    };
  },
  methods: {
		_cancel() {
			this.$emit('cancel')
		},
		_sure() {
			this.$emit('sure')
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
$input-width: 400px;
.add-wrap {
  .el-input__inner {
    width: $input-width;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/system/AddInform.vue